var _rect, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edge Elite \u2014 App Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    rx: 225,
    fill: "#0A0A0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 176v672",
    stroke: "#FF4D0D",
    strokeOpacity: 0.38,
    strokeWidth: 34,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 176,
    fill: "none",
    stroke: "#FF4D0D",
    strokeOpacity: 0.38,
    strokeWidth: 34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 72,
    fill: "#FF4D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.4f3a398f054966c11435a998bc52866b.svg";
export { ForwardRef as ReactComponent };